// import React, { useState, useEffect } from 'react'

// import logo1 from './jain logo.png'
// import { Col, Row, Spinner } from 'react-bootstrap'

// const NavBarStudentReg = () => {
//   return (
//     <Row
//       className=" py-1 shadow m-0 p-0 "
//       style={{
//         display: 'flex',
//         justifyContent: 'center',
//         backgroundColor: '#86caf7ff',
//       }}
//     >
      
//       <Col md={12}>
//         <img
//           src={logo1}
//           alt="Logo"
//           style={{ mixBlendMode: 'darken',height:"100px" }}
//         />
//          <span style={{fontSize:"24px",color:"black", paddingLeft:"10px"}}>Sheth R. D. Davada Digambar Jain Boarding, Sangli.</span>
//       </Col>
//     </Row>
//   )
// }

// export default NavBarStudentReg


import React from 'react'
import logo1 from './jain logo.png'
import { Col, Row } from 'react-bootstrap'

const NavBarStudentReg = () => {
  return (
    
    <>

            <Row
              className="py-3 m-0 p-0 nav-logo-fixed"
              style={{
                alignItems: 'center',
                backgroundColor: '#0783d6',
                color: 'white',
              }}
            >
              {/* LEFT SIDE (BOARDING NAME) */}
              <Col
                xs={12}
                md={2}
                lg={1}
                className="text-md-start text-center"
              >
                {/* MOBILE LOGO */}
                <div className="mb-2">
                  <img
                    src={logo1}
                    alt="Logo"
                    style={{ height: '90px',backgroundColor:"#a2d6f8",borderRadius:"50%" }}
                  />
                </div>
              </Col>
      
              <Col
                xs={12}
                md={5}
                lg={7}
                className="text-md-start text-center"
              >
                <span
                  style={{
                    fontSize: '25px',
                    fontWeight: '500',
                    lineHeight: '1.3',
                    color: 'white',
                  }}
                >
                  Sheth R. D. Davada Digambar Jain Boarding, Sangli.
                </span>
              </Col>

            </Row>
    </>
  )
}

export default NavBarStudentReg
